import { memo } from "react";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import Highlight from "./Highlight/Highlight";
import { MediaGroupedListView } from "@coworker/apprestructured/src/shared/components/MediaGroupedListView/MediaGroupedListView";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";

function MediaLocationsViewerFragmentDemo() {
  const mockGroupedMedias = {
    ROOM_SETTINGS: [
      {
        name: "A12",
        mediaType: "ROOM_SETTINGS",
        nbrArticles: 3,
        articleId: "271c2362-b8c2-4648-83c4-5bdc0c7c33cd",
        mediaId: "f9fce637-1cec-4cd3-8a60-d21a86f2edbd",
        groupId: "",
        groupName: "",
        parentMediaName: "",
        parentArticleCombinationNumber: "",
        area: "HFB 01",
      },
      {
        name: "A12",
        mediaType: "ROOM_SETTINGS",
        nbrArticles: 2,
        articleId: "b0ae56c2-0b6e-4ded-803a-8e676d382782",
        mediaId: "f9fce637-1cec-4cd3-8a60-d21a86f2edbd",
        groupId: "a4a1d476-7844-4f54-96bf-71d935e82441",
        groupName: "Wall B",
        parentMediaName: "",
        parentArticleCombinationNumber: "",
        area: "HFB 01",
      },
    ],
    PERIMETER_BREAK: [
      {
        name: "Demo Perimeter",
        mediaType: "PERIMETER_BREAK",
        nbrArticles: 1,
        articleId: "2e2ddfca-b0ac-4598-9766-ac43557c9c70",
        mediaId: "4f4f81d1-7961-463c-b4de-256657dc3356",
        groupId: "",
        groupName: "",
        parentMediaName: "",
        parentArticleCombinationNumber: "",
        area: "HFB 13",
      },
    ],
  };

  return (
    <Demo>
      <Name>MediaLocationsViewerFragment</Name>
      <Highlight>
        <FixaText textStyle="Heading.S" tagName="h2">
          Locations
        </FixaText>
        <MediaGroupedListView
          groupedMediasByType={mockGroupedMedias}
          showChevron={true}
          showQuantityLabel={true}
          additionalProps={{ inset: true }}
        />
      </Highlight>
    </Demo>
  );
}

export default memo(MediaLocationsViewerFragmentDemo);
